export const MemberAvatar = ({ m, size = "w-12 h-12 text-base" }) => (
  <span data-testid="member-avatar" className={`${size} shrink-0 rounded-full bg-[#0b2a47] text-[#e2c47a] font-heading font-extrabold flex items-center justify-center`}>
    {m?.iniciales || "?"}
  </span>
);
